"use client";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useContext } from "react";
import Avatar from "react-avatar";
import "./landing.scss";
// import StatusPanelWidget from "./widgetComponents/StatusPanelWidget";

// import { statusPanelData } from "../../data/WidgetsData";
import StatusTiles from "../Widgets/StatTiles/StatusTiles";
import { statusPanelData } from "../../data/widgetData";
import Focus from "../Widgets/Focus/Focus";
import QuickLinks from "../Widgets/QuickLinks/QuickLinksMainPage";
import TodoRC from "../Widgets/Todos/TodoRc";
import Logo from "../../images/NoLogo.svg";
import Header from "../layout/Header";
import { interactionData } from "../../utils/GeneralUtils";
import MessageCenterLanding from "./MessageCenterLanding";
import { BankUserContext } from "../../bankUserContext";
import { ErrorBoundary } from "react-error-boundary";
import FallBackUI from "../../ErrorHandling/FallbackHandler";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";
import RoleAuthorization from "../Authentication/RoleAuthorization";

interface LandingProps {
  LogoData: any;
}

const LandingPageView: React.FC<LandingProps> = ({ LogoData }) => {
  // const LandingPageView = (LandingProps: any) => {
  const [logosList, setLogosList] = useState<LandingProps[]>([]);
  const [renderTodos, setRenderTodos] = useState<boolean>(false);
  const [selectedInteractionIds, setSelectedInteractionIds] = useState<
    String[]
  >([]);
  const bankUserContext=useContext(BankUserContext);

  useEffect(() => {
    setLogosList(LogoData);
    
  }, [LogoData]);

  // useEffect(()=>{
  //   setRenderTodos(true);
  // },[bankUserContext])

  const statusFilters = (filterTodoId: string) => {
    if (filterTodoId) {
          setSelectedInteractionIds([filterTodoId]);
    }
    else{
      setSelectedInteractionIds([])
    }
  };

  // console.log(LogoData,"LandingProps")
  return (
    <div className="widget-main main-container">
      <div className="widgets-view view">
        <Header LogoData={logosList || []} />
        <div className="inner-section landing-body-wrap">
          {/* Inner Section */}
          {RoleAuthorization(Pages.landingPage , actionAuthorization.viewStatusTiles) && <StatusTiles statusFilters={statusFilters} />}
          <div className="mainComponent">
           {RoleAuthorization(Pages.landingPage , actionAuthorization.viewMyTodos) && <TodoRC interactionData={selectedInteractionIds} />}
            <div className="right-comp">
              {RoleAuthorization(Pages.landingPage , actionAuthorization.viewInfocus) && <Focus />}
             {RoleAuthorization(Pages.landingPage , actionAuthorization.viewMessageCenter) &&  <MessageCenterLanding />}
            </div>
          </div>
          {<QuickLinks />}
        </div>
      </div>
    </div>
  );
};

export default LandingPageView;
